export default function Step3(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M48.6825 44.2702C49.6353 41.9739 50.1614 39.4594 50.1614 36.8236V14.9402L30.1662 8.5L10.1726 14.9402V36.8236C10.0444 53.8039 31.024 62.754 43.5134 51.4864"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.7186 23.0836C32.489 19.8364 27.6404 19.2152 23.7875 21.2146L27.8545 25.3038L23.4492 29.7331L19.3822 25.6438C17.3937 29.5164 18.0129 34.3927 21.2411 37.64C24.2771 40.6911 28.7424 41.4206 32.4671 39.8368L45.3093 52.7503C46.8109 54.2601 49.2454 54.2587 50.7471 52.7503C52.2487 51.2405 52.2487 48.7927 50.7471 47.2829L37.9049 34.3708C39.4788 30.6258 38.7546 26.1361 35.7186 23.0836Z"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
